import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import './styles/Header.scss';

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    const isActive = (path) => {
        if (path === '/home' && location.pathname === '/') return true;
        return location.pathname === path;
    };

    return (
        <div className="header">
            <div className="logo-section">
                <Link to="/" onClick={closeMobileMenu}>
                    <img
                        src="/media/header/logo.svg"
                        alt="Sts. Vartanantz Ladies Guild Logo"
                        className="logo"
                    />
                </Link>
                <div className="church-info">
                    <h2 className="church-name">Sts. Vartanantz Ladies Guild</h2>
                    <p className="church-subtitle">Armenian Apostolic Church</p>
                </div>
            </div>

            {/* Mobile Menu Button */}
            <button 
                className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={toggleMobileMenu}
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            
            {/* Navigation Menu */}
            <div className={`menu-section ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                <div className="menu">
                    <Link 
                        to="/" 
                        className={isActive('/home') ? 'active' : ''}
                        onClick={closeMobileMenu}
                    >
                        Home
                    </Link>
                    <Link 
                        to="/executive-board"
                        className={isActive('/executive-board') ? 'active' : ''}
                        onClick={closeMobileMenu}
                    >
                        Executive Board
                    </Link>
                    <Link 
                        to="/mission"
                        className={isActive('/mission') ? 'active' : ''}
                        onClick={closeMobileMenu}
                    >
                        Mission & Bylaws
                    </Link>
                    <Link
                        to="/calendar"
                        className={isActive('/calendar') ? 'active' : ''}
                        onClick={closeMobileMenu}
                    >
                        Calendar
                    </Link>
                    <Link
                        to="/all-events"
                        className={isActive('/all-events') ? 'active' : ''}
                        onClick={closeMobileMenu}
                    >
                        Events
                    </Link>
                    {/* <Link
                        to="/past-events"
                        className={isActive('/past-events') ? 'active' : ''}
                        onClick={closeMobileMenu}
                    >
                        Past Events
                    </Link> */}
                    <Link 
                        to="/gallery"
                        className={isActive('/gallery') ? 'active' : ''}
                        onClick={closeMobileMenu}
                    >
                        Gallery
                    </Link>
                    <Link 
                        to="/membership"
                        className={isActive('/membership') ? 'active' : ''}
                        onClick={closeMobileMenu}
                    >
                        Why Join
                    </Link>
                </div>
                <a 
                    href="https://secure.myvanco.com/L-Z84F/home"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="donate-button"
                    onClick={closeMobileMenu}
                >
                    Donate
                </a>
            </div>
        </div>
    );
};

export default Header;
